import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useLoaderState, useKatex, CSSRefTransition, Throbber, SizeTransition } from '@utils/react';
import { usePostloadedContent } from './hook.postloaded-content.js';
import { container, content, throbber, POSTLOADED_TRANSITION_DURATION_MS, wrapper } from './organism.content.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function PostloadedModalContent(props) {
  const containerRef = useRef(null);
  const didShowLoader = useRef(false);
  const content$1 = usePostloadedContent(props.children);
  const showLoader = useLoaderState(content$1 === undefined, {
    delayMs: 25,
    durationMs: 1000
  });
  if (showLoader.current) {
    didShowLoader.current = true;
  }
  const showContent = !showLoader.current && content$1 !== undefined;
  useKatex(containerRef, [showContent]);
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapper),
    children: /*#__PURE__*/jsxs("div", {
      ref: containerRef,
      id: props.id,
      className: container,
      "data-content-component": "true",
      children: [!didShowLoader.current && showContent && /*#__PURE__*/jsx("div", {
        "data-inside": true,
        className: cx(content, props.className),
        children: content$1
      }), /*#__PURE__*/jsxs(TransitionGroup, {
        component: null,
        children: [showLoader.current && /*#__PURE__*/jsx(CSSRefTransition, {
          timeout: POSTLOADED_TRANSITION_DURATION_MS,
          classNames: throbber,
          children: ref => /*#__PURE__*/jsx("div", {
            ref: ref,
            className: throbber,
            children: /*#__PURE__*/jsx(Throbber, {}, "throbber")
          })
        }), didShowLoader.current && showContent && /*#__PURE__*/jsx(SizeTransition, {
          axis: "both",
          swappable: true,
          timeout: POSTLOADED_TRANSITION_DURATION_MS,
          classNames: content,
          children: ref => /*#__PURE__*/jsx("div", {
            ref: ref,
            className: cx(content, props.className),
            children: content$1
          })
        }, "content")]
      })]
    })
  });
}

export { PostloadedModalContent };
//# sourceMappingURL=organism.content.js.map
